var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{staticClass:"pa-0"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-img',{staticClass:"banner pt-0",attrs:{"data-test":"link_header_logo","src":_vm.$settings.url(_vm.$settings.banner)}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }